
import { i18nText } from '@/locales';
import {Form} from "@/form/form";
import {Validate} from "@/plugins/Vuelidate/Decorators";
import {required} from "vuelidate/lib/validators";
import {Component} from "vue-property-decorator";
import {RecoverMainRequestType} from "@/form/recover/recoverMain/recoverMain.types";

@Component
export default class RecoverMainForm extends Form{
    @Validate(required, i18nText("Введите телефон"))
    phone = '';
    getFormData(): RecoverMainRequestType {
        return {
            phone: this.phone,
            token: 'b62e68d04882a310cadb793ec9f62c8028eb0ceb3dc92fa495d87b103cb5c625'
        }
    }
}
